import { Handle, Position, NodeResizer, type NodeProps } from "@xyflow/react";
import { Play } from "@untitledui/icons";
import { useTranslation } from "react-i18next";

export const StartNode = ({ data, selected }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const label = (data?.label as string) || t('workflows.editor.defaultLabels.start');
    return (
        <div className="rounded-lg bg-utility-success-50 border-2 border-utility-success-500 shadow-md min-w-[120px] w-full h-full">
            <NodeResizer
                color="#10b981"
                isVisible={selected}
                minWidth={120}
                minHeight={50}
            />
            <Handle type="source" position={Position.Bottom} className="w-3 h-3 bg-utility-success-500" />
            <div className="flex items-center gap-2 px-3 py-2 h-full justify-center flex-wrap">
                <Play className="size-4 text-utility-success-600 flex-shrink-0" />
                <span className="text-sm font-semibold text-utility-success-700 break-words">{label}</span>
            </div>
        </div>
    );
};
